// extracted by mini-css-extract-plugin
export default {"input":"input_input__5m3cf"};